import * as React from 'react';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Grid from '@mui/material/Grid';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import { visuallyHidden } from '@mui/utils';
import Circular from '../components/Circularprogress';
import Modalopener from '../modal/Modal.jsx';
import Menuname from '../menu/menuinput.jsx';
// import Menuname from '../components/Supplymenu2.jsx';

import { Modal } from '@mui/material';
import Modalviewer from '../modal/Modalview.jsx';
import Modaldelete from '../modal/Modaldelete.jsx';
import Modalediter from '../modal/Modaledit.jsx';
import Search from '@mui/icons-material/Search';

import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getadmin } from '../redux/admin';
import { getfarmer } from '../redux/farmer';
import { getcontract } from '../redux/contract';
import Nodata from '../pages/nodatafound.jsx';



function createData(
  id,agent,farmer,status,yieldunit,amount,qtyBarter,unitBarter,quantity,unit,paymentterms,date,expectedyeild,actualyeild,inputlist,

  // id, farmername, batch, farmer, inputlist, quantity, unit, expectedyeild, actualyeild, yeildunit, Barterqty, Barterunit, paymentterms, datedistributed, approvepaymentdate, approveBarter, amountpaid, approvecontract, approvecontractdate, closecontract, closecontractdate, status, year, month,date
) {
  return {
    id,agent,farmer,status,yieldunit,amount,qtyBarter,unitBarter,quantity,unit,paymentterms,date,expectedyeild,actualyeild,inputlist,
  }}



var rows = [
  createData(1, 'Cupcake', 305, 3.7, 67, 4.3),
  createData(2, 'Donut', 452, 25.0, 51, 4.9),
  createData(3, 'Eclair', 262, 16.0, 24, 6.0),
  createData(4, 'Frozen yoghurt', 159, 6.0, 24, 4.0),
  createData(5, 'Gingerbread', 356, 16.0, 49, 3.9),
  createData(6, 'Honeycomb', 408, 3.2, 87, 6.5),
  createData(7, 'Ice cream sandwich', 237, 9.0, 37, 4.3),
  createData(8, 'Jelly Bean', 375, 0.0, 94, 0.0),
  createData(9, 'KitKat', 518, 26.0, 65, 7.0),
  createData(10, 'Lollipop', 392, 0.2, 98, 0.0),
  createData(11, 'Marshmallow', 318, 0, 81, 2.0),
  createData(12, 'Nougat', 360, 19.0, 9, 37.0),
  createData(13, 'Oreo', 437, 18.0, 63, 4.0),
];


function descendingComparator(a, b, orderBy, agentData) {
  let aValue = a[orderBy];
  let bValue = b[orderBy];
  
  // Handle special cases for different field types
  if (orderBy === 'farmername') {
    // For farmer, use the farmer field
    aValue = a.farmer || '';
    bValue = b.farmer || '';
  } else if (orderBy === 'request') {
    // For request, use the inputlist field
    aValue = a.inputlist || '';
    bValue = b.inputlist || '';
  } else if (orderBy === 'amount') {
    // For amount, ensure it's a number
    aValue = parseFloat(aValue) || 0;
    bValue = parseFloat(bValue) || 0;
  } else if (orderBy === 'status') {
    // For status, ensure we have a string value
    aValue = aValue || '';
    bValue = bValue || '';
  } else if (orderBy === 'agent') {
    // For agent, get the agent name
    const agentA = agentData.find(bug => bug.idnumber === aValue);
    const agentB = agentData.find(bug => bug.idnumber === bValue);
    aValue = agentA ? `${agentA.surname || ''} ${agentA.othername || ''}`.trim() : '';
    bValue = agentB ? `${agentB.surname || ''} ${agentB.othername || ''}`.trim() : '';
  }
  
  // Handle null/undefined values
  if (aValue === null || aValue === undefined) aValue = '';
  if (bValue === null || bValue === undefined) bValue = '';
  
  // Convert to strings for comparison if they're not numbers
  if (typeof aValue !== 'number' && typeof bValue !== 'number') {
    aValue = String(aValue).toLowerCase();
    bValue = String(bValue).toLowerCase();
  }
  
  if (bValue < aValue) {
    return -1;
  }
  if (bValue > aValue) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy, agentData) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy, agentData)
    : (a, b) => -descendingComparator(a, b, orderBy, agentData);
}

const headCells = [
 
  // {
  //   id: 'batch',
  //   numeric: false,
  //   disablePadding: false,
  //   label: 'Batch',
  // },  
  
  {
    id: 'farmername',
    numeric: false,
    disablePadding: false,
    label: 'Farmer`s Name',
  }, {
    id: 'request',
    numeric: false,
    disablePadding: false,
    label: 'Request',
  },
  {
    id: 'amount',
    numeric: false,
    disablePadding: false,
    label: 'Amount',
  },
  {
    id: 'status',
    numeric: false,
    disablePadding: false,
    label: 'Status',
  },
  {
    id: 'agent',
    numeric: false,
    disablePadding: false,
    label: 'Agent',
  }
  
];

function EnhancedTableHead(props) {
  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
    props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
      <TableCell
          
            align="left"
            padding='normal'
            
          >
            No.
            </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) {
  const { numSelected } = props;
  return (
    <Toolbar
      sx={[
        {
          pl: { sm: 2 },
          pr: { xs: 1, sm: 1 },
        },
        numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
        },
      ]}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: '1 1 100%' }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          sx={{ flex: '1 1 100%' }}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          Nutrition
        </Typography>
      )}
      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filter list">
          <IconButton>
            <FilterListIcon />
          </IconButton>
        </Tooltip>
      )}
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export default function EnhancedTable() {
  const dt = new Date()
  const time = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
  const day = dt.getUTCDate();
  const month = String(dt.getMonth() + 1).padStart(2, '0');
  const year = dt.getFullYear();
  const date = year + "-" + month + "-" + day;
  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]

  
  const dispatch = useDispatch()
  const admin = useSelector((state) => state.admin)
  const farmer = useSelector((state) => state.farmer)
  const contract = useSelector((state) => state.contract)
  const agent = useSelector((state) => state.agent)
  const staff = useSelector((state) => state.staff)

  var rows_ = [(contract || []).map((list, index) => createData(list._id,list.agent,list.farmer,list.status,list.yieldunit,list.amount,list.qtyBarter,list.unitBarter,list.quantity,list.unit,list.paymentterms,list.date,list.expectedyeild,list.actualyeild,list.inputlist ))]
  const [rows, setRows] = React.useState(rows_.length === 1 ? rows_[0] : [])
  
  const [order, setOrder] = React.useState('asc');
  const [Modalvalue, setModalvalue] = React.useState(false);
  const [Modalview, setModalview] = React.useState(false);
  const [Modaldeleter, setModaldeleter] = React.useState(false);
  const [Modaledit, setModaledit] = React.useState(false);
  const [Chosen, setChosen] = React.useState([]);
  const [orderBy, setOrderBy] = React.useState('name');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(true);
  const [rowsPerPage, setRowsPerPage] = React.useState(20);
  const [search, setSearch] = React.useState("");
  const [chosenname, setchosenname] = React.useState("")
  const [startDate, setStartDate] = React.useState('');
  const [endDate, setEndDate] = React.useState('');
  const [bystatus, setbystatus] = React.useState('none');
  // Add agent filter state
  const [byagent, setbyagent] = React.useState('none');

  var datepusher=[]

  // Memoized search function
  const searching = React.useCallback((e) => {
    setSearch(e.target.value);
    setPage(0); // Reset to first page when searching
  }, []);

  // Memoized filtered rows
  const filteredRows = React.useMemo(() => {
    let filtered = [...rows];
    
    // Apply search filter
    if (search) {
      const searchLower = search.toLowerCase();
      filtered = filtered.filter(row => 
        (row.farmer && row.farmer.toLowerCase().includes(searchLower)) ||
        (row.inputlist && row.inputlist.toLowerCase().includes(searchLower)) ||
        (row.status && row.status.toLowerCase().includes(searchLower)) ||
        (row.agent && agent.find(bug => bug.idnumber === row.agent)?.surname?.toLowerCase().includes(searchLower)) ||
        (row.agent && agent.find(bug => bug.idnumber === row.agent)?.othername?.toLowerCase().includes(searchLower))
      );
    }
    
    // Apply status filter
    if (bystatus !== 'none') {
      filtered = filtered.filter(row => {
        const rowStatus = row.status || '';
        return rowStatus.toLowerCase() === bystatus.toLowerCase();
      });
    }
    
    // Apply agent filter
    if (byagent !== 'none') {
      filtered = filtered.filter(row => {
        return row.agent === byagent;
      });
    }
    
    // Apply date range filter
    if (startDate || endDate) {
      filtered = filtered.filter(row => {
        const itemDate = new Date(row.date);
        const start = startDate ? new Date(startDate) : null;
        const end = endDate ? new Date(endDate) : null;
        
        if (start && itemDate < start) return false;
        if (end && itemDate > end) return false;
        return true;
      });
    }
    
    return filtered;
  }, [rows, search, bystatus, byagent, startDate, endDate, agent]);

  // Memoized visible rows with sorting and pagination
  const visibleRows = React.useMemo(() => {
    const sortedRows = [...filteredRows].sort(getComparator(order, orderBy, agent));
    return sortedRows.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );
  }, [filteredRows, order, orderBy, page, rowsPerPage, agent]);

  // Memoized empty rows calculation
  const emptyRows = React.useMemo(() => {
    return page > 0 ? Math.max(0, (1 + page) * rowsPerPage - filteredRows.length) : 0;
  }, [page, rowsPerPage, filteredRows.length]);

  // Update rows when data changes
  React.useEffect(() => {
    setRows(rows_.length === 1 ? rows_[0] : []);
  }, [contract, rows_]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const showdata=(event, data)=>{
     
    setModalvalue(true)
 
      
    setChosen(data)

   
  }

  const setoff=()=>{
    setModalvalue(false)
    setModaldeleter(false)
    setModaledit(false)

  }
 

  const setoffer=()=>{
    setModalview(false)
    setModaldeleter(false)
    setModaledit(false)
  }

  const setview=()=>{
    setModalview(true)
    
  }

const setdeleter=()=>{
    setModaldeleter(true)

  }
const setdistribute=(name)=>{
    setModaledit(true)
    setchosenname(name)

  }


  
  for(var i=0; i<=11;i++){
    datepusher.push(year-i)

  }

  
  return (
    <Box sx={{ width: '100%' }}>
    {Modalvalue===true &&  <Modalopener  value={Modalvalue} chosen={Chosen} product={Chosen.farmer} setfalse={setoff} name={chosenname}  Menu={<Menuname  name={chosenname} chosen={Chosen} value={Modalview} view={setview} delete={setdeleter} distribute={()=>setdistribute("Distribute Input")} farm={()=>setdistribute("Outgrower Farm Assessment")} training={()=>setdistribute("Outgrower Training Assessment")}  plot={()=>setdistribute("Demo Plot Assessment")} approverecovery={()=>setdistribute("Approve Recovery / Payment")}  approvecontract={()=>setdistribute("Approve Contract" )}  closecontract={()=>setdistribute("Close Contract")}  product={Chosen.farmer}  />}/>  }
    {/* {Modalvalue===true &&  <Modalopener  value={Modalvalue} chosen={Chosen} product={Chosen.farmername} setfalse={setoff} name={chosenname}  Menu={<Menuname  name={chosenname} chosen={Chosen} value={Modalview} view={setview} delete={setdeleter} distribute={()=>setdistribute("Distribute Input")} approverecovery={()=>setdistribute("Approve Recovery / Payment")}  approvecontract={()=>setdistribute("Approve Contract" )}  closecontract={()=>setdistribute("Close Contract")}  product={Chosen.name}  />}/>  } */}
   

    {Modalview===true &&  <Modalviewer
    details={{
      Agent:  (agent.find(bug=>bug.ID===Chosen.agent) && agent.find(bug=>bug.ID===Chosen.agent)?.lastname +" "+agent.find(bug=>bug.ID===Chosen.agent)?.othername || staff.find(bug=>bug.ID===Chosen.agent) && staff.find(bug=>bug.ID===Chosen.agent)?.lastname +" "+ staff.find(bug=>bug.ID===Chosen.agent)?.othername ) || 'No Agent',
      Farmer: Chosen.farmer  || 'No Farmer',
      Status: Chosen.status || 'No Status',
      Amount: Chosen.amount || 'No Amount',
      Actual_Quantity: `${Chosen.actualyeild || 0} ${Chosen.yieldunit || ''}` || 'No Principal',
      Barter_Quantity: `${Chosen.qtyBarter || 0} ${Chosen.unitBarter || ''}` || 'No Principal',
      Inputlist: Chosen.inputlist || 'No Input List',
      Date: Chosen.date || 'No Date'
    }}
    
    
    name="Contract Farming"  product={Chosen.farmer} chosen={Chosen} view={setview} setfalser={setoffer} value={Modalvalue}/>}
    {Modaldeleter===true &&  <Modaldelete name="Contract Farming" delete={"requisition"} dispatcher={getcontract}  product={Chosen.farmer} chosen={Chosen}  view={setdeleter} setfalser={setoffer} value={Modaldeleter}/>}
    {Modaledit===true &&  <Modalediter name={chosenname}  product={Chosen.farmer} chosen={Chosen}  view={setdistribute} setfalser={setoffer} value={Modaledit}/>}

      <Paper sx={{ width: '100%', mb: 2 }}>
        <TableContainer>



        <div style={{padding:"10px"}}>

<Grid container>
                    <Grid lg={4} xs={2} md={6}>
                        
                    <TextField
                    style={{marginTop:"8px"}}
                    type="date"
                    label="Start Date"
                    value={startDate}
                    size="small"
                    onChange={(e) => setStartDate(e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <TextField
                    style={{marginTop:"8px", marginLeft:"10px"}}
                    type="date"
                    label="End Date"
                    value={endDate}
                    size="small"
                    onChange={(e) => setEndDate(e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />

                    </Grid>
                  
                    <Grid lg={3} xs={2} md={5} style={{textAlign:"center"}}>
                      
 <div style={{position:"relative"}}> 
                    <Search id="searchbox"  style={{ position: "absolute", marginTop: "18px", marginLeft: "8px", color:"grey" }} /> <input type="search" onChange={(e) => searching(e)} placeholder="Search" style={{ padding: 10, paddingLeft: "38px", marginTop: 10, width: "100%", border: "solid", borderRadius: "5px", borderWidth: "0.5px", backgroundColor: "rgba(65,105,225, 0.05) ", borderColor: "#2196f3" }} />
                    </div> 

                    </Grid>

                    <Grid lg={5} xs={10} md={6}>

                    <TextField
                    style={{marginTop:"8px", marginLeft:"10px"}}
          id="outlined-select-status-native"
          select
          label="Filter By Status"
          // defaultValue="Ownership Type"
          value={bystatus}
          onChange={(e)=>setbystatus(e.target.value)}
          size="small"
          // onChange={(e)=>setbystatus(e.target.value)}
          slotProps={{
            select: {
              native: true,
            },
          }}
        //   helperText="Please select category"
        >
            <option key="none" value="none">All Statuses</option>
            <option key="Input Requested" value="Input Requested">Input Requested</option>
            <option key="Distributed" value="Distributed">Distributed</option>
            <option key="Approve Payment / Recovery" value="Approve Payment / Recovery">Approve Payment / Recovery</option>
            <option key="Approve Contract" value="Approve Contract">Approve Contract</option>
            <option key="Close Contract" value="Close Contract">Close Contract</option>         
                  
        </TextField>

        <TextField
          style={{marginTop:"8px", marginLeft:"10px"}}
          id="outlined-select-agent-native"
          select
          label="Filter By Agent"
          value={byagent}
          onChange={(e)=>setbyagent(e.target.value)}
          size="small"
          slotProps={{
            select: {
              native: true,
            },
          }}
        >
          <option key="none" value="none">All Agents</option>
          {agent.map((agentItem) => (
            <option key={agentItem.idnumber} value={agentItem.idnumber}>
              {agentItem.surname} {agentItem.othername} {agentItem.lastname}
            </option>
          ))}
          {staff.map((staffItem) => (
            <option key={staffItem.ID} value={staffItem.ID}>
              {staffItem.surname} {staffItem.othername} {staffItem.lastname} (Staff)
            </option>
          ))}
        </TextField>

                    
                </Grid>

</Grid>
</div>


          <Table
            sx={{ minWidth: 750 }}
            aria-labelledby="tableTitle"
            size={dense ? 'small' : 'medium'}
          >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              // onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={filteredRows.length}
            />
            <TableBody>
            {visibleRows.map((row, index) => {
                const isItemSelected = selected.includes(row.id);
                const labelId = `enhanced-table-checkbox-${index}`;

                return (
                  <TableRow
                    hover
                    onClick={(event)=>showdata(event, row)}
                    role="checkbox"
                    // aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={row.id}
                    // selected={isItemSelected}
                    sx={{ cursor: 'pointer' }}
                  >
                    <TableCell padding="normal">
                      
                      {(rowsPerPage*page)+index+1+"."}

                    </TableCell>
                    {/* <TableCell
                    
                      // component="th"
                      id={labelId}
                      scope="row"
                      // padding="normal"
                    >
                      {row.batch}
                    </TableCell> */}
                    <TableCell align="left">{row.farmer}</TableCell>
                    <TableCell align="left">{row.inputlist && (row.inputlist)}</TableCell>
                    <TableCell align="left">GHC {row.amount}</TableCell>
                    <TableCell align="left">{row.status}</TableCell>
                    <TableCell align="left">{(agent.find(bug=>bug.ID===row.agent) && agent.find(bug=>bug.ID===row.agent)?.lastname +" "+agent.find(bug=>bug.ID===row.agent)?.othername || staff.find(bug=>bug.ID===row.agent) && staff.find(bug=>bug.ID===row.agent)?.lastname +" "+ staff.find(bug=>bug.ID===row.agent)?.othername ) || 'No Agent'}</TableCell>
                  </TableRow>
                );
              })}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: (dense ? 33 : 53) * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        
        {filteredRows.length===0 && <Nodata/>}
          
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[30, 40, 50]}
          component="div"
          count={filteredRows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
      <FormControlLabel
        control={<Switch checked={dense} onChange={handleChangeDense} />}
        label="Dense padding"
      />
    </Box>
  );
}
